// The door an auth email belongs to. An email requested at The Ride's door is a The Ride: ATL email
// (subject, sender name, heading, link); at the IntelAgent door it is an IntelAgent email; clients get
// the client app's address. Shared by the Edge Functions and the tests; kept free of JSON imports so Deno can load it.
// The canonical addresses here must match src/config/signInBranding.json (a test checks that).
export const MAIL_DOORS = {
    platform: { key: 'platform', name: 'IntelAgent', origin: 'https://app.smarteknowledgy.com' },
    'the-ride-atl': { key: 'the-ride-atl', name: 'The Ride: ATL', origin: 'https://app.therideatl.com' },
    client: { key: 'client', name: 'The Ride: ATL', origin: 'https://book.therideatl.com' },
};

export const MAIL_POWERED_BY = 'Powered by smarTEKnowledgy';

function hostOf(value) {
    try { return new URL(String(value)).hostname.toLowerCase(); } catch { return ''; }
}

// A request from a canonical address decides the door by itself; anything else (an old vercel.app address,
// a preview, the native app) may only *name* one of the three doors. Nothing here can pick an arbitrary link target.
export function mailDoorFor({ origin = '', door = '' } = {}) {
    const host = hostOf(origin);
    const byHost = Object.values(MAIL_DOORS).find((candidate) => hostOf(candidate.origin) === host);
    if (byHost) return byHost;
    return Object.prototype.hasOwnProperty.call(MAIL_DOORS, door) ? MAIL_DOORS[door] : null;
}

export function mailDoorFromRequest(request, body = {}) {
    return mailDoorFor({ origin: request?.headers?.get?.('origin') ?? '', door: typeof body?.door === 'string' ? body.door : '' });
}

// The door's own sign-in address, e.g. https://app.therideatl.com/sign-in?auth_link=…
export function mailDoorLink(door, params = {}) {
    const link = new URL('/sign-in', door.origin);
    Object.entries(params).forEach(([name, value]) => link.searchParams.set(name, value));
    return link.toString();
}
